import { render, staticRenderFns } from "./searchProduct.vue?vue&type=template&id=271191a8&scoped=true"
import script from "./searchProduct.vue?vue&type=script&lang=js"
export * from "./searchProduct.vue?vue&type=script&lang=js"
import style0 from "./searchProduct.vue?vue&type=style&index=0&id=271191a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271191a8",
  null
  
)

export default component.exports